class ProductFavPopup extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-product-fav-popup-overlay]');
    this.closeButton = this.querySelector('[data-product-fav-popup-close]');
    this.favButton = this.querySelector('[data-product-fav-popup-fav]');
    this.isLoggedIn = this.dataset.loggedIn === 'true';
    this.loginUrl = this.dataset.loginUrl || '';
    this.wishlistUrl = this.dataset.wishlistUrl || '/pages/wishlist';
    this.scrollY = 0;
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }

    if (!this.shouldOpen()) return;

    this.bindEvents();
    requestAnimationFrame(() => this.open());
  }

  shouldOpen() {
    const pathname = window.location.pathname;
    const isProductPath = /\/products\//.test(pathname);
    const favParam = new URLSearchParams(window.location.search).get('fav');
    return isProductPath && favParam === '1';
  }

  bindEvents() {
    this.overlay?.addEventListener('click', () => this.close());
    this.closeButton?.addEventListener('click', () => this.close());
    this.favButton?.addEventListener('click', () => {
      if (this.isLoggedIn) {
        this.triggerWishlist();
        window.setTimeout(() => {
          window.location.href = this.wishlistUrl;
        }, 400);
      } else {
        this.redirectToLogin();
      }
    });
    document.addEventListener('keydown', this.onKeydown);
  }

  redirectToLogin() {
    if (!this.loginUrl) return;

    try {
      const url = new URL(this.loginUrl, window.location.origin);
      url.searchParams.set('return_url', window.location.pathname + window.location.search);
      window.location.href = url.toString();
    } catch (error) {
      window.location.href = this.loginUrl;
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }

  open() {
    this.scrollY = window.scrollY || window.pageYOffset;
    this.hidden = false;
    this.setAttribute('aria-hidden', 'false');
    document.body.style.top = `-${this.scrollY}px`;
    document.body.classList.add('product-fav-popup--open');
    requestAnimationFrame(() => this.classList.add('is-open'));
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('product-fav-popup--open');
    document.body.style.top = '';
    window.scrollTo(0, this.scrollY || 0);
    document.removeEventListener('keydown', this.onKeydown);
    this.removeFavParam();

    window.setTimeout(() => {
      this.hidden = true;
      this.setAttribute('aria-hidden', 'true');
    }, 300);
  }

  removeFavParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('fav')) return;

    url.searchParams.delete('fav');
    const nextSearch = url.searchParams.toString();
    const nextUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ''}${url.hash}`;
    window.history.replaceState({}, '', nextUrl);
  }

  triggerWishlist() {
    const wishlistButton = document.querySelector(
      '.follow-button wishlist-button-block .wk-button, wishlist-button-block .wk-button'
    );

    if (wishlistButton) {
      wishlistButton.click();
      return;
    }

    const swymButton = document.querySelector('.swym-add-to-wishlist, .swym-button');
    if (swymButton) {
      swymButton.click();
    }
  }
}

if (!customElements.get('product-fav-popup')) {
  customElements.define('product-fav-popup', ProductFavPopup);
}
